export enum ROUTE_NAMES {
  LOGIN,
}

export type TRoutes = {
  [route in ROUTE_NAMES]: string
}
